import React from 'react'
import PropTypes from 'prop-types'
import { StyledCheckBox } from './styles'
import { Box, Typography } from '@material-ui/core'
import { colors } from '@/theme'

export function TableHeader(props) {
  const { checkboxProps, title, helperText, bodyData } = props

  return (
    <Box display="flex" py={1} px={1}>
      <StyledCheckBox {...checkboxProps} />

      <Box>
        <Box display="flex" gridGap="1rem" mb={0.5}>
          <Typography
            variant="h3"
            style={{
              fontSize: '1rem',
              fontWeight: 'bold',
              color: colors.color800,
            }}
          >
            {title}
          </Typography>

          <Typography variant="caption">{helperText}</Typography>
        </Box>

        <Typography>{bodyData.join(' -- ')}</Typography>
      </Box>
    </Box>
  )
}

TableHeader.propTypes = {
  checkboxProps: PropTypes.object,
  title: PropTypes.string,
  helperText: PropTypes.string,
  bodyData: PropTypes.array,
}

TableHeader.defaultProps = {
  bodyData: [],
}

export default TableHeader
